import styles from "./Dashboard.module.css";

import AttendanceStats from "../../sections/AttendanceStats/AttendanceStats";
import AttendanceDetailsSection from "../../sections/AttendanceDetailsSection/AttendanceDetailsSection";
import AttendanceRingChart from "../../sections/AttendanceRingChart/AttendanceRingChart";
import QuickActionsSection from "../../sections/QuickActionsSection/QuickActionsSection";
import DailyActivitiesSection from "../../sections/DailyActivitiesSection/DailyActivitiesSection";
import NoticesSection from "../../sections/NoticesSection/NoticesSection";
import ParentCommunicationSection from "../../sections/ParentCommunicationSection/ParentCommunicationSection";
import { EventsSection } from "../../sections/EventsSection/EventsSection";
import { UpcomingHolidaysSection } from "../../sections/UpcomingHolidaysSection/UpcomingHolidaysSection";
import { UpcomingBirthdays } from "../../sections/UpcomingBirthdays/UpcomingBirthdays";
import { InstallationSection } from "../../sections/InstallationSection/InstallationSection";
import EnquiriesAndAdmissions from "../../sections/EnquiriesAndAdmissions/EnquiriesAndAdmissions";
import BillingAccounting from "../../sections/BillingAccounting/BillingAccounting";
import CopyRight from "../../components/CopyRight/CopyRight";

function Dashboard() {
  return (
    <div className={styles.Dashboard}>
      <div className={styles.SectionsContainer}>
        <div className={styles.Section1}>
          <AttendanceStats />
          <AttendanceDetailsSection />
          <AttendanceRingChart staffPercentage={13} studentPercentage={97} />
        </div>
        <QuickActionsSection />
        <div className={styles.Section2}>
          <DailyActivitiesSection />
          <NoticesSection />
          <ParentCommunicationSection />
        </div>
        <div className={styles.Section3}>
          <EnquiriesAndAdmissions />
          <EventsSection />
        </div>
        <div className={styles.Section4}>
          <BillingAccounting />
        </div>
        <div className={styles.Section5}>
          <UpcomingHolidaysSection />
          <UpcomingBirthdays />
          <InstallationSection />
        </div>
      </div>

      <CopyRight />
    </div>
  );
}

export default Dashboard;
